import breadcrumbs from './Contact_breadcrumbs';
import requests from './Contact_requests';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    requests,
  },
};
